import Link from 'next/link'
import { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from '~/hooks'
import { AddressZero } from '@ethersproject/constants'
import {
  StyledTokenSearch,
  SearchInputLeftIcon,
  SearchInput,
  SearchInputRightIcon,
  StyledSearchFeedback,
  IconQ,
} from '../styled'

interface Props {
  onSearch: (s: string) => void
  placeholder?: string
}

export const TokenSearchInput: React.FC<Props> = ({
  onSearch,
  placeholder,
}) => {
  const [searchText, setSearchText] = useState('')
  const { t, i18n } = useTranslation()
  const { isMobile } = useBreakpoint()
  const showFeedback = useMemo(
    () => searchText.toUpperCase() === 'ETH' || searchText === AddressZero,
    [searchText],
  )
  const feedbackURL = useMemo(
    () =>
      `https://support.tokenlon.im/hc/${
        i18n.resolvedLanguage === 'zh' ? 'zh-cn' : 'en-us'
      }/articles/7463636612116`,
    [i18n.resolvedLanguage],
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
    onSearch(e.target.value)
  }

  const reset = () => {
    setSearchText('')
    return false
  }

  useEffect(() => {
    onSearch(searchText)
  }, [searchText, onSearch])

  return (
    <>
      <StyledTokenSearch>
        <SearchInputLeftIcon />
        <SearchInput
          className="token-switch-input"
          value={searchText}
          type="text"
          spellCheck="false"
          autoFocus={!isMobile}
          onChange={onChange}
          placeholder={
            placeholder ? t(placeholder) : t('search_token_or_address')
          }
        />
        {searchText ? <SearchInputRightIcon onClick={reset} /> : null}
        {showFeedback && (
          <StyledSearchFeedback>
            {t('lo_search_feedback_eth')}
            <Link href={feedbackURL} target="_blank">
              <IconQ />
            </Link>
          </StyledSearchFeedback>
        )}
      </StyledTokenSearch>
    </>
  )
}
